import { Reveal } from "@/components/Reveal";
import { SectionTitle } from "@/components/Practice";

const PATHS = [
  {
    id: "buyers",
    title: "For Buyers",
    steps: [
      "List your requirement on the marketplace",
      "Access a curated database of suppliers",
      "Connect directly — no middle layers",
    ],
  },
  {
    id: "suppliers",
    title: "For Suppliers",
    steps: [
      "Join the supplier database",
      "Get discovered by buyers with live requirements",
      "Win business on capability, not cold calls",
    ],
  },
];

export default function TwoDoors() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="border-t border-[#E5E5DE] py-20 md:py-28">
      <SectionTitle kicker="How It Works" title="Two doors, one marketplace" />
      <div className="max-w-[1100px] mx-auto px-6 mt-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        {PATHS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.12}>
            <div data-testid={`path-${p.id}`}>
              <h3 className="font-serif text-3xl md:text-4xl text-[#16180F] text-center">{p.title}</h3>
              <ol className="mt-8">
                {p.steps.map((s, j) => (
                  <li key={j} className="flex items-baseline gap-5 border-t border-[#E5E5DE] py-5">
                    <span className="font-serif text-xl text-[#4C8C1E]">{j + 1}.</span>
                    <span className="text-base font-light text-[#55564A]">{s}</span>
                  </li>
                ))}
              </ol>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
